import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import API from "@/lib/api";
import CountryCodeSelect from "@/components/CountryCodeSelect";

const _UNUSED = [
  { code: "+93", country: "Afghanistan", flag: "🇦🇫" },
  { code: "+355", country: "Albania", flag: "🇦🇱" },
  { code: "+213", country: "Algeria", flag: "🇩🇿" },
  { code: "+376", country: "Andorra", flag: "🇦🇩" },
  { code: "+244", country: "Angola", flag: "🇦🇴" },
  { code: "+54", country: "Argentina", flag: "🇦🇷" },
  { code: "+374", country: "Armenia", flag: "🇦🇲" },
  { code: "+61", country: "Australia", flag: "🇦🇺" },
  { code: "+43", country: "Austria", flag: "🇦🇹" },
  { code: "+994", country: "Azerbaijan", flag: "🇦🇿" },
  { code: "+1242", country: "Bahamas", flag: "🇧🇸" },
  { code: "+973", country: "Bahrain", flag: "🇧🇭" },
  { code: "+880", country: "Bangladesh", flag: "🇧🇩" },
  { code: "+375", country: "Belarus", flag: "🇧🇾" },
  { code: "+32", country: "Belgium", flag: "🇧🇪" },
  { code: "+501", country: "Belize", flag: "🇧🇿" },
  { code: "+229", country: "Benin", flag: "🇧🇯" },
  { code: "+975", country: "Bhutan", flag: "🇧🇹" },
  { code: "+591", country: "Bolivia", flag: "🇧🇴" },
  { code: "+387", country: "Bosnia & Herzegovina", flag: "🇧🇦" },
  { code: "+267", country: "Botswana", flag: "🇧🇼" },
  { code: "+55", country: "Brazil", flag: "🇧🇷" },
  { code: "+673", country: "Brunei", flag: "🇧🇳" },
  { code: "+359", country: "Bulgaria", flag: "🇧🇬" },
  { code: "+226", country: "Burkina Faso", flag: "🇧🇫" },
  { code: "+257", country: "Burundi", flag: "🇧🇮" },
  { code: "+855", country: "Cambodia", flag: "🇰🇭" },
  { code: "+237", country: "Cameroon", flag: "🇨🇲" },
  { code: "+1", country: "Canada", flag: "🇨🇦" },
  { code: "+238", country: "Cape Verde", flag: "🇨🇻" },
  { code: "+236", country: "Central African Republic", flag: "🇨🇫" },
  { code: "+235", country: "Chad", flag: "🇹🇩" },
  { code: "+56", country: "Chile", flag: "🇨🇱" },
  { code: "+86", country: "China", flag: "🇨🇳" },
  { code: "+57", country: "Colombia", flag: "🇨🇴" },
  { code: "+269", country: "Comoros", flag: "🇰🇲" },
  { code: "+242", country: "Congo", flag: "🇨🇬" },
  { code: "+243", country: "Congo (DRC)", flag: "🇨🇩" },
  { code: "+506", country: "Costa Rica", flag: "🇨🇷" },
  { code: "+385", country: "Croatia", flag: "🇭🇷" },
  { code: "+53", country: "Cuba", flag: "🇨🇺" },
  { code: "+357", country: "Cyprus", flag: "🇨🇾" },
  { code: "+420", country: "Czech Republic", flag: "🇨🇿" },
  { code: "+45", country: "Denmark", flag: "🇩🇰" },
  { code: "+253", country: "Djibouti", flag: "🇩🇯" },
  { code: "+1809", country: "Dominican Republic", flag: "🇩🇴" },
  { code: "+593", country: "Ecuador", flag: "🇪🇨" },
  { code: "+20", country: "Egypt", flag: "🇪🇬" },
  { code: "+503", country: "El Salvador", flag: "🇸🇻" },
  { code: "+240", country: "Equatorial Guinea", flag: "🇬🇶" },
  { code: "+291", country: "Eritrea", flag: "🇪🇷" },
  { code: "+372", country: "Estonia", flag: "🇪🇪" },
  { code: "+268", country: "Eswatini", flag: "🇸🇿" },
  { code: "+251", country: "Ethiopia", flag: "🇪🇹" },
  { code: "+679", country: "Fiji", flag: "🇫🇯" },
  { code: "+358", country: "Finland", flag: "🇫🇮" },
  { code: "+33", country: "France", flag: "🇫🇷" },
  { code: "+241", country: "Gabon", flag: "🇬🇦" },
  { code: "+220", country: "Gambia", flag: "🇬🇲" },
  { code: "+995", country: "Georgia", flag: "🇬🇪" },
  { code: "+49", country: "Germany", flag: "🇩🇪" },
  { code: "+233", country: "Ghana", flag: "🇬🇭" },
  { code: "+30", country: "Greece", flag: "🇬🇷" },
  { code: "+502", country: "Guatemala", flag: "🇬🇹" },
  { code: "+224", country: "Guinea", flag: "🇬🇳" },
  { code: "+245", country: "Guinea-Bissau", flag: "🇬🇼" },
  { code: "+592", country: "Guyana", flag: "🇬🇾" },
  { code: "+509", country: "Haiti", flag: "🇭🇹" },
  { code: "+504", country: "Honduras", flag: "🇭🇳" },
  { code: "+852", country: "Hong Kong", flag: "🇭🇰" },
  { code: "+36", country: "Hungary", flag: "🇭🇺" },
  { code: "+354", country: "Iceland", flag: "🇮🇸" },
  { code: "+91", country: "India", flag: "🇮🇳" },
  { code: "+62", country: "Indonesia", flag: "🇮🇩" },
  { code: "+98", country: "Iran", flag: "🇮🇷" },
  { code: "+964", country: "Iraq", flag: "🇮🇶" },
  { code: "+353", country: "Ireland", flag: "🇮🇪" },
  { code: "+972", country: "Israel", flag: "🇮🇱" },
  { code: "+39", country: "Italy", flag: "🇮🇹" },
  { code: "+225", country: "Ivory Coast", flag: "🇨🇮" },
  { code: "+1876", country: "Jamaica", flag: "🇯🇲" },
  { code: "+81", country: "Japan", flag: "🇯🇵" },
  { code: "+962", country: "Jordan", flag: "🇯🇴" },
  { code: "+7", country: "Kazakhstan", flag: "🇰🇿" },
  { code: "+254", country: "Kenya", flag: "🇰🇪" },
  { code: "+383", country: "Kosovo", flag: "🇽🇰" },
  { code: "+965", country: "Kuwait", flag: "🇰🇼" },
  { code: "+996", country: "Kyrgyzstan", flag: "🇰🇬" },
  { code: "+856", country: "Laos", flag: "🇱🇦" },
  { code: "+371", country: "Latvia", flag: "🇱🇻" },
  { code: "+961", country: "Lebanon", flag: "🇱🇧" },
  { code: "+266", country: "Lesotho", flag: "🇱🇸" },
  { code: "+231", country: "Liberia", flag: "🇱🇷" },
  { code: "+218", country: "Libya", flag: "🇱🇾" },
  { code: "+370", country: "Lithuania", flag: "🇱🇹" },
  { code: "+352", country: "Luxembourg", flag: "🇱🇺" },
  { code: "+853", country: "Macao", flag: "🇲🇴" },
  { code: "+261", country: "Madagascar", flag: "🇲🇬" },
  { code: "+265", country: "Malawi", flag: "🇲🇼" },
  { code: "+60", country: "Malaysia", flag: "🇲🇾" },
  { code: "+960", country: "Maldives", flag: "🇲🇻" },
  { code: "+223", country: "Mali", flag: "🇲🇱" },
  { code: "+356", country: "Malta", flag: "🇲🇹" },
  { code: "+222", country: "Mauritania", flag: "🇲🇷" },
  { code: "+230", country: "Mauritius", flag: "🇲🇺" },
  { code: "+52", country: "Mexico", flag: "🇲🇽" },
  { code: "+373", country: "Moldova", flag: "🇲🇩" },
  { code: "+976", country: "Mongolia", flag: "🇲🇳" },
  { code: "+382", country: "Montenegro", flag: "🇲🇪" },
  { code: "+212", country: "Morocco", flag: "🇲🇦" },
  { code: "+258", country: "Mozambique", flag: "🇲🇿" },
  { code: "+95", country: "Myanmar", flag: "🇲🇲" },
  { code: "+264", country: "Namibia", flag: "🇳🇦" },
  { code: "+977", country: "Nepal", flag: "🇳🇵" },
  { code: "+31", country: "Netherlands", flag: "🇳🇱" },
  { code: "+64", country: "New Zealand", flag: "🇳🇿" },
  { code: "+505", country: "Nicaragua", flag: "🇳🇮" },
  { code: "+227", country: "Niger", flag: "🇳🇪" },
  { code: "+234", country: "Nigeria", flag: "🇳🇬" },
  { code: "+389", country: "North Macedonia", flag: "🇲🇰" },
  { code: "+47", country: "Norway", flag: "🇳🇴" },
  { code: "+968", country: "Oman", flag: "🇴🇲" },
  { code: "+92", country: "Pakistan", flag: "🇵🇰" },
  { code: "+507", country: "Panama", flag: "🇵🇦" },
  { code: "+675", country: "Papua New Guinea", flag: "🇵🇬" },
  { code: "+595", country: "Paraguay", flag: "🇵🇾" },
  { code: "+51", country: "Peru", flag: "🇵🇪" },
  { code: "+63", country: "Philippines", flag: "🇵🇭" },
  { code: "+48", country: "Poland", flag: "🇵🇱" },
  { code: "+351", country: "Portugal", flag: "🇵🇹" },
  { code: "+974", country: "Qatar", flag: "🇶🇦" },
  { code: "+40", country: "Romania", flag: "🇷🇴" },
  { code: "+7", country: "Russia", flag: "🇷🇺" },
  { code: "+250", country: "Rwanda", flag: "🇷🇼" },
  { code: "+966", country: "Saudi Arabia", flag: "🇸🇦" },
  { code: "+221", country: "Senegal", flag: "🇸🇳" },
  { code: "+381", country: "Serbia", flag: "🇷🇸" },
  { code: "+232", country: "Sierra Leone", flag: "🇸🇱" },
  { code: "+65", country: "Singapore", flag: "🇸🇬" },
  { code: "+421", country: "Slovakia", flag: "🇸🇰" },
  { code: "+386", country: "Slovenia", flag: "🇸🇮" },
  { code: "+252", country: "Somalia", flag: "🇸🇴" },
  { code: "+27", country: "South Africa", flag: "🇿🇦" },
  { code: "+82", country: "South Korea", flag: "🇰🇷" },
  { code: "+211", country: "South Sudan", flag: "🇸🇸" },
  { code: "+34", country: "Spain", flag: "🇪🇸" },
  { code: "+94", country: "Sri Lanka", flag: "🇱🇰" },
  { code: "+249", country: "Sudan", flag: "🇸🇩" },
  { code: "+597", country: "Suriname", flag: "🇸🇷" },
  { code: "+46", country: "Sweden", flag: "🇸🇪" },
  { code: "+41", country: "Switzerland", flag: "🇨🇭" },
  { code: "+963", country: "Syria", flag: "🇸🇾" },
  { code: "+886", country: "Taiwan", flag: "🇹🇼" },
  { code: "+992", country: "Tajikistan", flag: "🇹🇯" },
  { code: "+255", country: "Tanzania", flag: "🇹🇿" },
  { code: "+66", country: "Thailand", flag: "🇹🇭" },
  { code: "+228", country: "Togo", flag: "🇹🇬" },
  { code: "+1868", country: "Trinidad & Tobago", flag: "🇹🇹" },
  { code: "+216", country: "Tunisia", flag: "🇹🇳" },
  { code: "+90", country: "Turkey", flag: "🇹🇷" },
  { code: "+993", country: "Turkmenistan", flag: "🇹🇲" },
  { code: "+256", country: "Uganda", flag: "🇺🇬" },
  { code: "+380", country: "Ukraine", flag: "🇺🇦" },
  { code: "+971", country: "UAE", flag: "🇦🇪" },
  { code: "+44", country: "UK", flag: "🇬🇧" },
  { code: "+1", country: "USA", flag: "🇺🇸" },
  { code: "+598", country: "Uruguay", flag: "🇺🇾" },
  { code: "+998", country: "Uzbekistan", flag: "🇺🇿" },
  { code: "+58", country: "Venezuela", flag: "🇻🇪" },
  { code: "+84", country: "Vietnam", flag: "🇻🇳" },
  { code: "+967", country: "Yemen", flag: "🇾🇪" },
  { code: "+260", country: "Zambia", flag: "🇿🇲" },
];

const DATA_TYPES = [
  { value: "coding", label: "Code / Software repositories" },
  { value: "operations_data", label: "Business documents (emails, tickets, wikis, SOPs)" },
  { value: "coding_and_operations", label: "Both code and business documents" },
  { value: "academic_stem", label: "Academic / STEM content" },
  { value: "cad_models", label: "CAD / Engineering models (STEP, IGES, Parasolid)" },
  { value: "other", label: "Other" },
];

const COUNTRIES = [
  "Afghanistan","Albania","Algeria","Andorra","Angola","Antigua and Barbuda","Argentina","Armenia","Australia",
  "Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bhutan",
  "Bolivia","Bosnia and Herzegovina","Botswana","Brazil","Brunei","Bulgaria","Burkina Faso","Burundi","Cabo Verde",
  "Cambodia","Cameroon","Canada","Central African Republic","Chad","Chile","China","Colombia","Comoros",
  "Congo (Brazzaville)","Congo (Kinshasa)","Costa Rica","Croatia","Cuba","Cyprus","Czech Republic","Denmark",
  "Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Eritrea",
  "Estonia","Eswatini","Ethiopia","Fiji","Finland","France","Gabon","Gambia","Georgia","Germany","Ghana",
  "Greece","Grenada","Guatemala","Guinea","Guinea-Bissau","Guyana","Haiti","Honduras","Hungary","Iceland",
  "India","Indonesia","Iran","Iraq","Ireland","Israel","Italy","Jamaica","Japan","Jordan","Kazakhstan","Kenya",
  "Kiribati","Kuwait","Kyrgyzstan","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein",
  "Lithuania","Luxembourg","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Marshall Islands",
  "Mauritania","Mauritius","Mexico","Micronesia","Moldova","Monaco","Mongolia","Montenegro","Morocco",
  "Mozambique","Myanmar","Namibia","Nauru","Nepal","Netherlands","New Zealand","Nicaragua","Niger","Nigeria",
  "North Korea","North Macedonia","Norway","Oman","Pakistan","Palau","Panama","Papua New Guinea","Paraguay",
  "Peru","Philippines","Poland","Portugal","Qatar","Romania","Russia","Rwanda","Saint Kitts and Nevis",
  "Saint Lucia","Saint Vincent and the Grenadines","Samoa","San Marino","Sao Tome and Principe","Saudi Arabia",
  "Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","Solomon Islands","Somalia",
  "South Africa","South Korea","South Sudan","Spain","Sri Lanka","Sudan","Suriname","Sweden","Switzerland",
  "Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor-Leste","Togo","Tonga","Trinidad and Tobago",
  "Tunisia","Turkey","Turkmenistan","Tuvalu","Uganda","Ukraine","United Arab Emirates","United Kingdom",
  "United States","Uruguay","Uzbekistan","Vanuatu","Vatican City","Venezuela","Vietnam","Yemen","Zambia","Zimbabwe",
  "Other",
];

const field = {
  width: "100%",
  background: "rgba(0,0,0,0.4)",
  border: "1px solid #2A2622",
  borderRadius: "8px",
  padding: "11px 14px",
  color: "#F0EBE0",
  fontFamily: "var(--sans)",
  fontSize: "15px",
  boxSizing: "border-box",
  outline: "none",
  appearance: "none",
  WebkitAppearance: "none",
};
const fieldErr = { ...field, borderColor: "#C45C45" };
const label = {
  display: "block",
  fontSize: "13px",
  color: "#9A938A",
  marginBottom: "7px",
  fontFamily: "var(--sans)",
  fontWeight: 500,
};
const err = { color: "#C45C45", fontSize: "12px", marginTop: "5px" };

export default function ApplyPage() {
  const [form, setForm] = useState({
    full_name: "",
    work_email: "",
    mobile_country_code: "",
    mobile_number: "",
    company: "",
    linkedin_url: "",
    data_types: [],
    country: "",
  });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [utms, setUtms] = useState({});
  const [headline, setHeadline] = useState("Sell Your Data to AI Labs");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const content = params.get("utm_content") || "";
    setUtms({
      utm_source: params.get("utm_source") || "",
      utm_campaign: params.get("utm_campaign") || "",
      utm_content: content,
    });
    if (content.includes("cobol")) setHeadline("Sell Your COBOL Codebase to AI Labs");
    else if (content.includes("enterprise")) setHeadline("Sell Your Enterprise Data to AI Labs");
    else if (content.includes("coding")) setHeadline("Sell Your Code to AI Labs");

    // Meta pixel PageView
    if (!window.fbq) {
      window._fbq = window.fbq = function () {
        if (window.fbq.callMethod) window.fbq.callMethod.apply(window.fbq, arguments);
        else window.fbq.queue.push(arguments);
      };
      window.fbq.push = window.fbq;
      window.fbq.loaded = true;
      window.fbq.version = "2.0";
      window.fbq.queue = [];
      const s = document.createElement("script");
      s.async = true;
      s.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(s);
    }
    window.fbq("init", "1428555762554589");
    window.fbq("track", "PageView");
  }, []);

  const set = (k, v) => {
    setForm(f => ({ ...f, [k]: v }));
    setErrors(e => ({ ...e, [k]: "" }));
  };

  const toggleDataType = (value) => {
    setForm(f => ({
      ...f,
      data_types: f.data_types.includes(value)
        ? f.data_types.filter(d => d !== value)
        : [...f.data_types, value],
    }));
    setErrors(e => ({ ...e, data_types: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!form.full_name.trim()) errs.full_name = "Required";
    if (!form.work_email.trim()) errs.work_email = "Required";
    if (!form.mobile_number.trim()) errs.mobile_number = "Required";
    if (!form.company.trim()) errs.company = "Required";
    if (!form.linkedin_url.trim()) errs.linkedin_url = "Required";
    else if (!form.linkedin_url.trim().toLowerCase().includes("linkedin.com")) errs.linkedin_url = "Must be a LinkedIn URL (linkedin.com/in/…)";
    if (!form.data_types.length) errs.data_types = "Please select at least one";
    if (!form.country) errs.country = "Please select one";
    if (Object.keys(errs).length) { setErrors(errs); return; }

    setSubmitting(true);
    const eventId = crypto.randomUUID();
    const fbp = document.cookie.match(/_fbp=([^;]+)/)?.[1] || "";
    const fbc = document.cookie.match(/_fbc=([^;]+)/)?.[1] || "";
    try {
      await axios.post(`${API}/vendors`, {
        full_name: form.full_name.trim(),
        work_email: form.work_email.trim(),
        company: form.company.trim(),
        linkedin_url: form.linkedin_url.trim() || null,

        domains: form.data_types,
        data_volume: null,
        data_formats: [],
        description: "Meta Ads intake — nalandadata.ai/apply",
        mobile_country_code: form.mobile_country_code,
        mobile_number: form.mobile_number.trim(),
        notes: `Country: ${form.country}`,
        source: "meta",
        utm_source: utms.utm_source || null,
        utm_campaign: utms.utm_campaign || null,
        utm_content: utms.utm_content || null,
        event_id: eventId,
        fbp: fbp || null,
        fbc: fbc || null,
        source_url: window.location.href,
      });
      setSubmitted(true);
      if (window.fbq) window.fbq("track", "Lead", {}, { eventID: eventId });
      if (window.gtag) window.gtag("event", "generate_lead");
    } catch (err) {
      if (err?.response?.status === 409) {
        alert("This email has already been submitted. Our team will be in touch.");
      } else {
        alert("Submission failed. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Apply — Sell Your Data to AI Labs | Nalandadata</title>
        <meta name="description" content="We buy high-quality data from founders, operators and developers to train frontier AI models. Takes 2 minutes." />
        <meta name="robots" content="noindex" />
      </Helmet>

      <div style={{ paddingTop: "96px", paddingBottom: "80px", background: "#0A0A0A", minHeight: "100vh" }}>
        <div className="s-wrap" style={{ maxWidth: "600px" }}>

          <p className="s-eyebrow">Vendor Programme</p>

          <h1 style={{
            fontFamily: "var(--sans)",
            fontSize: "clamp(28px, 4.5vw, 44px)",
            fontWeight: 800,
            letterSpacing: "-0.025em",
            lineHeight: 1.1,
            color: "#F0EBE0",
            margin: "0 0 14px",
          }}>
            {headline}
          </h1>

          <p style={{ fontFamily: "var(--sans)", fontSize: "16px", color: "#9A938A", lineHeight: 1.65, margin: "0 0 24px" }}>
            We buy high-quality data from founders, operators and developers to train frontier AI models.{" "}
            <span style={{ color: "#F0EBE0", fontWeight: 600 }}>Takes 2 minutes.</span>{" "}
            Our team will reach out within 48 hours with an offer.
          </p>

          {/* Trust signals */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "32px" }}>
            {[
              { label: "48-hr response" },
              { label: "NDA signed" },
              { label: "Frontier AI lab buyers" },
            ].map(t => (
              <div key={t.label} style={{
                display: "inline-flex", alignItems: "center", gap: "6px",
                border: "1px solid #2A2622", borderRadius: "20px",
                padding: "5px 12px", fontSize: "12px", color: "#9A938A",
                fontFamily: "var(--sans)",
              }}>
                <span style={{ width: "5px", height: "5px", borderRadius: "50%", background: "#C8A96E", flexShrink: 0 }} />
                {t.label}
              </div>
            ))}
          </div>

          <div style={{ height: "1px", background: "#2A2622", marginBottom: "36px" }} />

          {submitted ? (
            <div style={{
              background: "#111111",
              border: "1px solid #2A2622",
              borderRadius: "12px",
              padding: "40px 32px",
              textAlign: "center",
            }}>
              <div style={{ fontSize: "32px", marginBottom: "16px" }}>✓</div>
              <h2 style={{ fontFamily: "var(--sans)", color: "#F0EBE0", fontWeight: 700, fontSize: "20px", margin: "0 0 10px" }}>
                Thanks — we'll be in touch!
              </h2>
              <p style={{ fontFamily: "var(--sans)", color: "#9A938A", fontSize: "15px", margin: 0 }}>
                Our team will review your application and reach out within{" "}
                <strong style={{ color: "#F0EBE0" }}>48 hours</strong> with a data offer.
                Keep an eye on your email.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} noValidate style={{ display: "flex", flexDirection: "column", gap: "22px" }}>

              {/* Full name */}
              <div>
                <label style={label}>Full name <span style={{ color: "#C8A96E" }}>*</span></label>
                <input
                  type="text"
                  placeholder="Your full name"
                  value={form.full_name}
                  onChange={e => set("full_name", e.target.value)}
                  style={errors.full_name ? fieldErr : field}
                />
                {errors.full_name && <p style={err}>{errors.full_name}</p>}
              </div>

              {/* Work email */}
              <div>
                <label style={label}>Work email <span style={{ color: "#C8A96E" }}>*</span></label>
                <input
                  type="email"
                  placeholder="you@company.com"
                  value={form.work_email}
                  onChange={e => set("work_email", e.target.value)}
                  style={errors.work_email ? fieldErr : field}
                />
                {errors.work_email && <p style={err}>{errors.work_email}</p>}
              </div>

              {/* Phone */}
              <div>
                <label style={label}>Phone / WhatsApp <span style={{ color: "#C8A96E" }}>*</span></label>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  <CountryCodeSelect
                    value={form.mobile_country_code}
                    onChange={v => set("mobile_country_code", v)}
                    required
                  />
                  <input
                    type="tel"
                    placeholder="10-digit number"
                    value={form.mobile_number}
                    onChange={e => set("mobile_number", e.target.value)}
                    style={{ ...(errors.mobile_number ? fieldErr : field), flex: 1, minWidth: "140px" }}
                  />
                </div>
                {errors.mobile_number && <p style={err}>{errors.mobile_number}</p>}
              </div>

              {/* Company */}
              <div>
                <label style={label}>Company name <span style={{ color: "#C8A96E" }}>*</span></label>
                <input
                  type="text"
                  placeholder="Your company or startup name"
                  value={form.company}
                  onChange={e => set("company", e.target.value)}
                  style={errors.company ? fieldErr : field}
                />
                {errors.company && <p style={err}>{errors.company}</p>}
              </div>

              {/* LinkedIn */}
              <div>
                <label style={label}>LinkedIn profile URL <span style={{ color: "#C8A96E" }}>*</span></label>
                <input
                  type="url"
                  placeholder="https://linkedin.com/in/yourname"
                  value={form.linkedin_url}
                  onChange={e => set("linkedin_url", e.target.value)}
                  style={errors.linkedin_url ? fieldErr : field}
                />
                {errors.linkedin_url && <p style={err}>{errors.linkedin_url}</p>}
              </div>

              {/* Data type — multi-select */}
              <div>
                <label style={label}>What kind of data do you have? <span style={{ color: "#C8A96E" }}>*</span> <span style={{ color: "#6B655C", fontWeight: 400 }}>(select all that apply)</span></label>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  {DATA_TYPES.map((opt, i) => {
                    const selected = form.data_types.includes(opt.value);
                    return (
                      <label key={opt.value} style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        background: selected ? "rgba(200,169,110,0.08)" : "#111111",
                        border: `1px solid ${selected ? "#C8A96E" : errors.data_types ? "#C45C45" : "#2A2622"}`,
                        borderRadius: "8px",
                        padding: "11px 14px",
                        cursor: "pointer",
                        fontFamily: "var(--sans)",
                        color: "#F0EBE0",
                        fontSize: "14px",
                        transition: "border-color 0.15s",
                        userSelect: "none",
                      }}
                        onClick={() => toggleDataType(opt.value)}
                      >
                        <span style={{
                          width: "20px", height: "20px", borderRadius: "4px", flexShrink: 0,
                          border: `2px solid ${selected ? "#C8A96E" : "#3A3530"}`,
                          background: selected ? "#C8A96E" : "transparent",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: "12px", fontWeight: 700, color: "#0A0A0A",
                          transition: "all 0.15s",
                        }}>
                          {selected ? "✓" : ""}
                        </span>
                        {opt.label}
                      </label>
                    );
                  })}
                </div>
                {errors.data_types && <p style={err}>{errors.data_types}</p>}
              </div>

              {/* Country */}
              <div>
                <label style={label}>Country <span style={{ color: "#C8A96E" }}>*</span></label>
                <div style={{ position: "relative" }}>
                  <select
                    value={form.country}
                    onChange={e => set("country", e.target.value)}
                    style={{
                      ...(errors.country ? fieldErr : field),
                      paddingRight: "36px",
                      cursor: "pointer",
                    }}
                  >
                    <option value="" disabled>Select your country</option>
                    {COUNTRIES.map(c => (
                      <option key={c} value={c} style={{ background: "#111111", color: "#F0EBE0" }}>{c}</option>
                    ))}
                  </select>
                  <span style={{
                    position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)",
                    color: "#9A938A", pointerEvents: "none", fontSize: "12px",
                  }}>▾</span>
                </div>
                {errors.country && <p style={err}>{errors.country}</p>}
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={submitting}
                style={{
                  background: submitting ? "#9A7B4F" : "#C8A96E",
                  color: "#0A0A0A",
                  border: "none",
                  borderRadius: "8px",
                  padding: "14px 28px",
                  fontFamily: "var(--sans)",
                  fontWeight: 700,
                  fontSize: "15px",
                  cursor: submitting ? "not-allowed" : "pointer",
                  letterSpacing: "0.01em",
                  marginTop: "4px",
                  transition: "background 0.15s",
                  width: "100%",
                }}
              >
                {submitting ? "Submitting..." : "Submit — We'll be in touch within 48 hours"}
              </button>

            </form>
          )}

          {/* FAQ */}
          <div style={{ marginTop: "56px", borderTop: "1px solid #2A2622", paddingTop: "40px" }}>
            <p style={{ fontFamily: "var(--mono, monospace)", fontSize: "12px", letterSpacing: "0.18em", textTransform: "uppercase", color: "#C8A96E", marginBottom: "24px" }}>
              Common questions
            </p>
            {[
              { q: "Will my data be published publicly?", a: "No. Your data is sold under a direct licensing agreement to AI labs and is never published publicly." },
              { q: "How does payment work?", a: "We evaluate your dataset, make an offer, and pay via bank transfer once data is delivered and verified." },
              { q: "What formats do you accept?", a: "Most formats work — .zip archives, GitHub repos, Google Drive, S3 buckets. Our team will guide you through the handover." },
              { q: "Is there an NDA?", a: "Yes. We sign an NDA before reviewing any data." },
              { q: "How long does evaluation take?", a: "We respond within 48 hours with an initial assessment and offer if your data is a fit." },
            ].map(({ q, a }) => (
              <div key={q} style={{ borderBottom: "1px solid #1C1A17", paddingBottom: "20px", marginBottom: "20px" }}>
                <p style={{ fontFamily: "var(--sans)", fontSize: "14px", fontWeight: 600, color: "#F0EBE0", margin: "0 0 8px" }}>{q}</p>
                <p style={{ fontFamily: "var(--sans)", fontSize: "14px", color: "#9A938A", margin: 0, lineHeight: 1.65 }}>{a}</p>
              </div>
            ))}
          </div>

        </div>
      </div>
    </>
  );
}
